export enum TokenType {
  WEB = 'WEB_JWT_TOKEN',
  DESKTOP = 'DESKTOP_JWT_TOKEN',
}
